export default __webpack_public_path__ + "static/media/instagram.0d317a81.svg";